import { TRANSACTIONS_FETCH } from '../constants/transactionsTypes';

export function transactionsFetch() {
  return {
    type: TRANSACTIONS_FETCH
  };
}



// WEBPACK FOOTER //
// ./app/actions/transactionsActions.js